import React, {FunctionComponent, MouseEvent} from 'react';
import './CartItemEditable.less';
import {CartItemShort} from 'compositions/cart-item-short/CartItemShort.tsx';
import {EntryEdit} from '../entry-edit/EntryEdit.tsx';
import {ListSplitter} from 'elements/list-splitter/ListSplitter.tsx';
import {getMenuEntryTotalPrice} from 'helpers/order-line.helper.ts';
import {ModifierGroup, MenuEntryModifierSelections, ModifierGroupId} from 'helpers/modifier.helper.types.ts';

interface CartItemEditableProps {
	quantity: number,
	name: string,
	price: number,
	modifierGroups: Array<ModifierGroup>,
	modifierSelections: MenuEntryModifierSelections,
	onQuantityDecClick: (event: MouseEvent) => void,
	onQuantityIncClick: (event: MouseEvent) => void,
	onModifierGroupClick: (e: MouseEvent, clickedModifierGroupId: ModifierGroupId) => void,
}

export const CartItemEditable: FunctionComponent<CartItemEditableProps> = ({
																																						 quantity,
																																						 name,
																																						 price,
																																						 modifierGroups = [],
																																						 modifierSelections,
																																						 onQuantityDecClick,
																																						 onQuantityIncClick,
																																						 onModifierGroupClick,
																																					 }) => {
	return (

		<div className="cart-item-editable">
			<div className="cart-item-editable__container">
				<div className="cart-item-editable__title">
					<CartItemShort name={name}
												 price={getMenuEntryTotalPrice(price, quantity, modifierGroups, modifierSelections)}/>
				</div>
				<ListSplitter isAlignByContainer/>
				<div className="cart-item-editable__controls">
					<EntryEdit
						quantity={quantity}
						onQuantityDecClick={onQuantityDecClick}
						onQuantityIncClick={onQuantityIncClick}
						modifierGroups={modifierGroups}
						modifierSelections={modifierSelections}
						onModifierGroupClick={onModifierGroupClick}
						isSmall
					/>
				</div>
			</div>
		</div>
	);
};
